// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nhtml{\n    margin: 0px;\n    padding: 0px;\n    height: 100%;\n    width: 100%;\n    font-size: 14px;\n    color: #333;\n    font-family: 'PingFang SC';\n    overflow: hidden;\n}\nbody {\n    height: 100%;\n    width: 100%;\n    margin: 0px;\n    background: red linear-gradient(to right, #395DD4, #5A89F3);\n}\n.box {\n    max-width: 30%;\n    margin: 0 auto;\n    background: #fff;\n    padding: 20px;\n    border-radius: 5px;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
